/**
 * @desc: 支付路由映射
 * @created: 2020/6/2
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T4/paymentRouting'

export default {
  namespaced: true,
  state: {
    checkoutList: []
  },
  getters: {
    checkoutList: state => state.checkoutList
  },
  mutations: {
    setCheckoutList: (state, data) => {
      state.checkoutList = data
    }
  },
  actions: {
    async getListData(ctx, payload) {
      const res = await Models.getListData(payload)
      return (res && res.status === 200 && res.data) || {}
    },

    async getPaymentChannels(ctx, payload) {
      const res = await Models.getPaymentChannels(payload)
      const initData = [{ value: '', label: '全部' }]
      if (res && res.status === 200) {
        const result = res.data.map(elem => {
          const buffer = {}

          buffer.value = elem.id
          buffer.label = elem.passagewayName
          return buffer
        })

        return initData.concat(result)
      }
      else {
        return initData
      }
    },

    async getPaymentDetails(ctx, payload) {
      const res = await Models.getPaymentDetails(payload)
      return (res && res.status === 200 && res.data) || {}
    },

    async sendRegisteredOne(ctx, payload) {
      return await Models.sendRegisteredOne(payload)
    },

    async sendRegisteredList(ctx, payload) {
      return await Models.sendRegisteredList(payload)
    }
  }
}
